import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'common/drawers/facilityDrawer/CLOSE',
  OPEN_ERROR: 'common/drawers/facilityDrawer/OPEN_ERROR',
  OPEN_REQUEST: 'common/drawers/facilityDrawer/OPEN_REQUEST',
  OPEN_SUCCESS: 'common/drawers/facilityDrawer/OPEN_SUCCESS',
  SAVE_ERROR: 'common/drawers/facilityDrawer/SAVE_ERROR',
  SAVE_REQUEST: 'common/drawers/facilityDrawer/SAVE_REQUEST',
  SAVE_SUCCESS: 'common/drawers/facilityDrawer/SAVE_SUCCESS',
  SET_FACILITY: 'common/drawers/facilityDrawer/SET_FACILITY',
};

export const facilityDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  setFacility: ({ facility }) => ({
    type: types.SET_FACILITY,
    payload: { facility },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit facility',
  ),
  request: ({ accountId, callBack, facilityId, mode }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      accountId,
      callBack,
      facilityId,
      mode,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save facility',
  ),
  request: ({
    address1,
    address2,
    attention,
    city,
    country,
    name,
    postalCode,
    salespersonId,
    state,
  }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      address1,
      address2,
      attention,
      city,
      country,
      name,
      postalCode,
      salespersonId,
      state,
    },
  }),
  success: ({ facilityId, facility }) => ({
    type: types.SAVE_SUCCESS,
    payload: { facilityId, facility },
  }),
};
